export default __webpack_public_path__ + "img/bc1b7f918529ac9804a3a1073514a48c.svg";